import {Component, Optional} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-confirmation-dialog-delete-adx-booking-udid',
    templateUrl: './confirmation-dialog-delete-adx-booking-udid.component.html',
    standalone: false
})
export class ConfirmationDialogDeleteAdxBookingUdidComponent {
    constructor(@Optional() public confirmationDialogRef: MatDialogRef<ConfirmationDialogDeleteAdxBookingUdidComponent>){}

    okClick(){
      this.confirmationDialogRef.close(true);    
    }

    onNoClick(){
      this.confirmationDialogRef.close(false);
    }
}